import React, { useState } from "react";
import Logo from "../../assets/images/logo.png";
import footerlogo from "../../assets/footerlogo.png";
import { Link } from "react-router-dom";
import { useStore } from "../../utils/store";
import { toast } from "react-toastify";
import additionalApi from "../../apis/additional.api";
import {
  FaInstagram,
  FaTwitter,
  FaFacebookF,
  FaLink,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPhone,
} from "react-icons/fa";

const Footer = () => {
  const { basicSettings } = useStore();
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    additionalApi.addSubscriber({
      payload: { email },
      success: (res) => {
        toast.success(
          "Thank you for subscribing! You'll receive the latest updates and news.",
          { position: "top-center", autoClose: 2000 }
        );
        setEmail("");
      },
      error: (err) => {
        toast.error(
          err?.response?.data?.message ||
          "Oops! Something went wrong. Please try again later.",
          { position: "top-center", autoClose: 2000 }
        );
      },
    });
  };

  return (
    <footer className="bg-gradient-to-br from-[#3a1c5c] via-[#52326b] to-[#662d50] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 lg:py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-6 sm:gap-8 lg:gap-12">
          
          {/* Brand Section */}
          <div className="sm:col-span-2 lg:col-span-3 space-y-3 sm:space-y-4">
            <div className="space-y-2 sm:space-y-3">
              <img
                loading="lazy"
                src={basicSettings?.logo || Logo}
                alt="TicketVerz Logo"
                className="w-32 sm:w-36 lg:w-40 h-auto object-contain"
              />
              <img
                loading="lazy"
                src="https://ticketverz-images.s3.eu-central-1.amazonaws.com/home/footerlogo.png"
                alt="Footer Badge"
                className="w-24 sm:w-28 lg:w-32 h-auto object-contain"
              />
            </div>
            <p className="text-zinc-300 text-xs sm:text-sm leading-relaxed max-w-xs">
              Your trusted platform for discovering and booking amazing events and experiences.
            </p>
          </div>

          {/* Plan Events */}
          <div className="lg:col-span-2">
            <h3 className="text-white text-sm sm:text-base font-bold uppercase mb-3 sm:mb-4 pb-2 border-b-2 border-pink-500">
              Plan Events
            </h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link 
                  to="/registerOrganizer" 
                  className="text-zinc-300 text-xs sm:text-sm hover:text-white hover:translate-x-1 transition-all duration-200 inline-block"
                >
                  Create Events
                </Link>
              </li>
              <li>
                <Link 
                  to="/registerOrganizer"
                  className="text-zinc-300 text-xs sm:text-sm hover:text-white hover:translate-x-1 transition-all duration-200 inline-block"
                >
                  Create Movies
                </Link>
              </li>
              <li>
                <Link 
                  to="/registerOrganizer"
                  className="text-zinc-300 text-xs sm:text-sm hover:text-white hover:translate-x-1 transition-all duration-200 inline-block"
                >
                  Become Organizer
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">
            <h3 className="text-white text-sm sm:text-base font-bold uppercase mb-3 sm:mb-4 pb-2 border-b-2 border-pink-500">
              Quick Links
            </h3>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link 
                  to="/termsandcondition"
                  className="text-zinc-300 text-xs sm:text-sm hover:text-white hover:translate-x-1 transition-all duration-200 inline-block"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link 
                  to="/imprint"
                  className="text-zinc-300 text-xs sm:text-sm hover:text-white hover:translate-x-1 transition-all duration-200 inline-block"
                >
                  Imprint
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact"
                  className="text-zinc-300 text-xs sm:text-sm hover:text-white hover:translate-x-1 transition-all duration-200 inline-block"
                >
                  Contact Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacypolicy"
                  className="text-zinc-300 text-xs sm:text-sm hover:text-white hover:translate-x-1 transition-all duration-200 inline-block"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Newsletter Section */}
          <div className="sm:col-span-2 lg:col-span-5">
            <h3 className="text-white text-sm sm:text-base font-bold uppercase mb-3 sm:mb-4 pb-2 border-b-2 border-pink-500">
              Stay in the Loop
            </h3>
            <p className="text-zinc-300 text-xs sm:text-sm leading-relaxed mb-4 sm:mb-5">
              Join our mailing list to stay updated with our newest events, concerts, and exclusive offers.
            </p>
            <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
                <input
                  className="flex-1 px-3 sm:px-4 py-2.5 sm:py-3 rounded-lg bg-white/10 border border-white/20 text-white placeholder-zinc-400 text-xs sm:text-sm focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent backdrop-blur-sm transition-all"
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  required
                />
                <button
                  type="submit"
                  className="w-full sm:w-auto px-5 sm:px-6 py-2.5 sm:py-3 bg-gradient-to-r from-pink-600 to-purple-600 text-white text-xs sm:text-sm font-semibold rounded-lg hover:from-pink-700 hover:to-purple-700 transform hover:scale-105 active:scale-95 transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap"
                >
                  Subscribe Now
                </button>
              </div>
            </form>

            {/* Social Media */}
            <div className="mt-6 sm:mt-8">
              <h4 className="text-white text-xs sm:text-sm font-semibold mb-3 sm:mb-4">Connect With Us</h4>
              <div className="flex flex-wrap gap-3 sm:gap-4">
                <a
                  href="https://www.instagram.com/ticketverz/#"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group"
                  aria-label="Instagram"
                >
                  <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-gradient-to-r from-pink-500 to-yellow-500 flex items-center justify-center transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-12 shadow-md hover:shadow-lg">
                    <FaInstagram size={18} className="text-white" />
                  </div>
                </a>

                <a
                  href="https://x.com/ticketverz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group"
                  aria-label="Twitter"
                >
                  <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-gradient-to-r from-blue-400 to-blue-600 flex items-center justify-center transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-12 shadow-md hover:shadow-lg">
                    <FaTwitter size={18} className="text-white" />
                  </div>
                </a>

                <a
                  href="https://www.facebook.com/people/TicketVerz/100087786116453/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group"
                  aria-label="Facebook"
                >
                  <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-gradient-to-r from-blue-600 to-indigo-600 flex items-center justify-center transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-12 shadow-md hover:shadow-lg">
                    <FaFacebookF size={18} className="text-white" />
                  </div>
                </a>

                <a
                  href="https://linktr.ee/ticketverz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group"
                  aria-label="Linktree"
                >
                  <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-12 shadow-md hover:shadow-lg">
                    <FaLink size={18} className="text-white" />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 my-6 sm:my-8"></div>

        {/* Bottom Footer */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4">
          <p className="text-zinc-300 text-xs sm:text-sm text-center md:text-left">
            © {new Date().getFullYear()} {basicSettings?.website_title || "TicketVerz"}. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center items-center gap-3 sm:gap-4 md:gap-6 text-zinc-300 text-[10px] sm:text-xs">
            <span className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Secure Payment</span>
            <span className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Trusted Platform</span>
            <span className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">24/7 Support</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;